export default __webpack_public_path__ + "static/media/imagem.8ae9816d.png";